import { render, staticRenderFns } from "./DropdowAssurancePage.vue?vue&type=template&id=5175662c&scoped=true"
import script from "./DropdowAssurancePage.vue?vue&type=script&lang=js"
export * from "./DropdowAssurancePage.vue?vue&type=script&lang=js"
import style0 from "./DropdowAssurancePage.vue?vue&type=style&index=0&id=5175662c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5175662c",
  null
  
)

export default component.exports